import enLocale from "../i18n/en";
import arLocale from "../i18n/ar";

/**
 * The shared FormDrawer in src/Components.jsx renders Yup errors as
 *   translate("CREATE_REQUEST." + meta.error)
 * which means the Yup error message must be a key that exists in the locale
 * dictionary. Locale dicts are static at build time, so per-vendor amounts
 * (which are arbitrary) can't be pre-seeded.
 *
 * To get a clean "Must be at least 1000" / "Cannot exceed 6000" without
 * touching the shared FormDrawer (used everywhere), we augment the locale
 * dictionaries at runtime when a V2 product page mounts with a vendor.
 *
 * Mutating an imported module object is unusual but safe here — the locale
 * files just export plain objects, and entries we add are additive (we never
 * overwrite an existing key). Idempotent: re-running with the same amount is
 * a no-op.
 *
 * Yup error keys we emit:
 *   `MUST_BE_ATLEAST_<min>`  — passed as the .min() message in vendor pages
 *   `CANNOT_EXCEED_<max>`    — passed as the .max() message in vendor pages
 *
 * Returns the two Yup error keys so the caller can plug them straight into
 * the Yup chain.
 */
export const ensureDynamicAmountTranslations = (min, max) => {
  const minKey = `MUST_BE_ATLEAST_${min}`;
  const maxKey = `CANNOT_EXCEED_${max}`;

  if (!enLocale.CREATE_REQUEST[minKey]) {
    enLocale.CREATE_REQUEST[minKey] = `Must be at least ${min}`;
  }
  if (!enLocale.CREATE_REQUEST[maxKey]) {
    enLocale.CREATE_REQUEST[maxKey] = `Cannot exceed ${max}`;
  }
  if (!arLocale.CREATE_REQUEST[minKey]) {
    arLocale.CREATE_REQUEST[minKey] = `يجب أن يكون على الأقل ${min}`;
  }
  if (!arLocale.CREATE_REQUEST[maxKey]) {
    arLocale.CREATE_REQUEST[maxKey] = `لا يمكن أن يتجاوز ${max}`;
  }

  return { minKey, maxKey };
};
